import { v4 as uuidv4 } from 'uuid';
export const generateKey = (prepend = '') => prepend + '--' + uuidv4();
//# sourceMappingURL=generateKey.js.map